var map = {
	"./assets/clickable/tiktok.svg": "f2291d0d26f2ca6f78e1",
	"./assets/disabled/tiktok.svg": "d4d459f093ea9c98775f",
	"./assets/original/tiktok.svg": "abc3375ccd6f4d06ea9e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7d65dd8a10b548e54d70";